import isObject from 'lodash/isObject';
/**
 * Removes dynamic styles which is RCE specific block data
 */ export const filterDynamicStyles = (whitelist, content)=>{
    const blockMap = content.getBlockMap();
    const blocks = blockMap.map((block)=>{
        let altered = false;
        if (!block) {
            return block;
        }
        const newData = block.getData().map((data, k)=>{
            if (k !== 'dynamicStyles') {
                return data;
            }
            for(const key in data){
                if (!isObject(data)) {
                    continue;
                }
                if (!whitelist.find((ok)=>ok.test(key))) {
                    delete data[key];
                    altered = true;
                }
            }
            return data;
        });
        return altered ? block === null || block === void 0 ? void 0 : block.set('data', newData) : block;
    });
    return content.merge({
        blockMap: blockMap.merge(blocks)
    });
};
